import { SuperbetRouteConfig } from '@superbet-group/web.types';

import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { Title } from '@app/router/constants/Title';
import { defaultLayout } from '@app/router/utils';
import PromotionsInfoPage from '@pages/PromotionsInfoPage.vue';

import { profilePage } from '@pages/ProfilePage';
import { AnalyticsScreenNames } from '@src/app/utils/analyticsScreenNames';
import { loadAsyncWithLoadingState } from '@src/app/utils/loadAsyncComponent';

export const promotionsRoutes: SuperbetRouteConfig[] = [
    {
        path: Link.GrowthMarketing.PromotionsInfo,
        name: RouteName.GrowthMarketing.PromotionsInfo,
        components: {
            ...defaultLayout,
            content: PromotionsInfoPage,
        },
        meta: {
            title: Title.GrowthMarketing.PromotionsInfo,
            layoutClass: 'promotions-page',
        },
    },
    {
        path: Link.BonusAndComms.PromotionHub,
        name: RouteName.BonusAndComms.PromotionHub,
        components: {
            ...profilePage,
            content: () => import('@app/promotionHub/shared/components/PromotionHubContainer.vue'),
            subnav: loadAsyncWithLoadingState<unknown>(() => import('@app/promotionHub/shared/components/PromotionHubPageHeader.vue')),
            mobileSubnav: loadAsyncWithLoadingState<unknown>(() => import('@app/promotionHub/shared/components/PromotionHubPageHeader.vue')),
        },
        meta: {
            title: Title.BonusAndComms.PromotionHub,
            layoutClass: 'my-account',
            superAnalytics: {
                pageName: AnalyticsScreenNames.promotionsAndBonuses,
            },
            headerTitle: 'bonus_comms.promotion_hub_title',
        },
    },
];
